import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import guestWelcomeIllustration from '../../assets/images/guestWelcomeIllustration.png';

/*
 * Props.
 */

/*
 * Style.
 */

const StyledContentDiv = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-row-gap: 12px;
  justify-items: center;
  position: relative;
  background-color: ${(p) => p.theme.foreground};
  border-radius: 16px;
  margin: 24px 24px 0px;
  width: 272px;
  padding: 16px;
`;

const StyledImg = styled.img`
  max-width: 100%;
`;

const StyledTitleDiv = styled.div`
  font-weight: ${fontWeights.bold};
  text-align: center;
  font-size: 18px;
`;

const StyledDescriptionDiv = styled.div`
  text-align: center;
  font-size: 14px;
  max-width: 238px;
  color: ${(p) => p.theme.greys.shade80};
  line-height: 21px;
`;

/*
 * Component.
 */

export const VisitorViewerSidebarContentWelcome: FC = () => (
  <StyledContentDiv>
    <StyledImg src={guestWelcomeIllustration} alt="welcome-to-front" />
    <StyledTitleDiv>
      <Trans id="visitor-sidebar-welcome-title-v3">Welcome to Front!</Trans>
    </StyledTitleDiv>
    <StyledDescriptionDiv>
      <Trans id="visitor-sidebar-welcome-description-v3">
        Front allows anyone to collaborate on any customer conversation. You&apos;ve been added as a guest to
        this one. Comment below to join in!
      </Trans>
    </StyledDescriptionDiv>
  </StyledContentDiv>
);
